import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  Box,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { formatMoney, getDivisionName } from "../../../constants/utils";

const CollapsibleTable = ({
  modalDataWithoutDivision,
  modalData,
  showDetailedView,
  isTopTenOverDueTab = false,
}) => {
  const [openRows, setOpenRows] = useState({});

  const toggleRow = (customerCode) => {
    setOpenRows((prev) => ({
      ...prev,
      [customerCode]: !prev[customerCode],
    }));
  };

  const getTableHeaderCell = (headerName, cellWidth = 100) => {
    return (
      <TableCell
        style={{
          backgroundColor: "black",
          color: "white",
          padding: "4px",
          fontWeight: "bold",
          width: cellWidth,
          textAlign: "center",
        }}
      >
        {headerName}
      </TableCell>
    );
  };

  const getSubTableHeaderCell = (headerName, cellWidth = 100) => {
    return (
      <TableCell
        style={{
          backgroundColor: "#909090",
          color: "white",
          padding: "5px",
          fontWeight: "bold",
          width: cellWidth,
          textAlign: "center",
        }}
      >
        {headerName}
      </TableCell>
    );
  };

  const getTableBodyCell = (value, textColor = "black") => {
    return (
      <TableCell
        sx={{
          padding: "2px",
          color: textColor,
          textAlign: "center",
        }}
      >
        {value}
      </TableCell>
    );
  };

  return (
    <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
      <Table
        stickyHeader
        style={{
          tableLayout: "fixed",
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <TableHead>
          <TableRow
            style={{
              position: "sticky",
              top: 0,
              zIndex: 2,
            }}
          >
            <TableCell style={{ backgroundColor: "black", width: 20 }} />
            {getTableHeaderCell("Customer Code")}
            {getTableHeaderCell("Customer Name", 200)}
            {getTableHeaderCell("Division")}
            {getTableHeaderCell("Net Balance")}
            {getTableHeaderCell("Overdue")}
            {isTopTenOverDueTab && getTableHeaderCell("Not Overdue")}
            {getTableHeaderCell("Provision Amount")}
            {showDetailedView && (
              <>
                {getTableHeaderCell("Days > 365")}
                {getTableHeaderCell("Days 181-365")}
                {getTableHeaderCell("Days 91-180")}
                {getTableHeaderCell("Days 61-90")}
                {getTableHeaderCell("Days 46-60")}
                {getTableHeaderCell("Days 31-45")}
                {getTableHeaderCell("Days 0-30")}
              </>
            )}
            {getTableHeaderCell("Security Deposit")}
            {getTableHeaderCell("Payment Class")}
            {getTableHeaderCell("Avg Payment Days")}
            {getTableHeaderCell("Status")}
          </TableRow>
        </TableHead>
        <TableBody>
          {modalDataWithoutDivision.map((row) => {
            const history = modalData.filter(
              (item) => item.customerCode === row.customerCode
            );

            return (
              <React.Fragment key={row.customerCode}>
                <TableRow>
                  {getTableBodyCell(
                    history.length > 1 && (
                      <IconButton onClick={() => toggleRow(row.customerCode)}>
                        {openRows[row.customerCode] ? (
                          <KeyboardArrowUp />
                        ) : (
                          <KeyboardArrowDown />
                        )}
                      </IconButton>
                    )
                  )}
                  {getTableBodyCell(row.customerCode)}
                  {getTableBodyCell(row.customerName)}
                  {getTableBodyCell(row.division)}
                  {getTableBodyCell(formatMoney(row.netBalance?.toFixed(0)))}
                  {getTableBodyCell(formatMoney(row.overdue?.toFixed(0)))}
                  {isTopTenOverDueTab &&
                    getTableBodyCell(
                      row.netBalance > 0 && row.overdue > 0
                        ? formatMoney(
                            (row.netBalance - row.overdue)?.toFixed(0)
                          )
                        : "-"
                    )}
                  {getTableBodyCell(
                    formatMoney(
                      (row.daysGreaterThan_365 + row.days331_365 / 2)?.toFixed(
                        0
                      )
                    )
                  )}
                  {showDetailedView && (
                    <>
                      {getTableBodyCell(
                        formatMoney(row.daysGreaterThan_365?.toFixed(0))
                      )}
                      {getTableBodyCell(
                        formatMoney(row.days331_365?.toFixed(0))
                      )}
                      {getTableBodyCell(
                        formatMoney(row.days181_330?.toFixed(0))
                      )}
                      {getTableBodyCell(
                        formatMoney(row.days151_180?.toFixed(0))
                      )}
                      {getTableBodyCell(
                        formatMoney(row.days61_150?.toFixed(0))
                      )}
                      {getTableBodyCell(formatMoney(row.days31_60?.toFixed(0)))}
                      {getTableBodyCell(formatMoney(row.days0_30?.toFixed(0)))}
                    </>
                  )}
                  {getTableBodyCell(
                    formatMoney(row.securityDeposit?.toFixed(0))
                  )}
                  {getTableBodyCell(row.paymentClass)}
                  {getTableBodyCell(row.averagePaymentDays)}
                  {getTableBodyCell(
                    row.lastBillingDate ? "Active" : "In-Active",
                    row.lastBillingDate ? "green" : "red"
                  )}
                </TableRow>
                {history.length > 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                    >
                      <Collapse in={openRows[row.customerCode]}>
                        <Box margin={1}>
                          <Table
                            size="small"
                            style={{
                              tableLayout: "fixed",
                              width: "100%",
                              borderCollapse: "collapse",
                            }}
                          >
                            <TableHead>
                              <TableRow>
                                {getSubTableHeaderCell("Division")}
                                {getSubTableHeaderCell("Net Balance")}
                                {getSubTableHeaderCell("Overdue")}
                                {getSubTableHeaderCell("Provision Amt", 120)}
                                {getSubTableHeaderCell("Days > 365")}
                                {getSubTableHeaderCell("Days 181-365", 110)}
                                {/* <TableCell>Division</TableCell>
                                <TableCell>Net Balance</TableCell>
                                <TableCell>Overdue</TableCell>
                                <TableCell>Provision Amount</TableCell>
                                <TableCell>{`Days > 365`}</TableCell>
                                <TableCell>Days 181-365 </TableCell> */}
                                {showDetailedView && (
                                  <>
                                    {getSubTableHeaderCell("Days 91-180")}
                                    {getSubTableHeaderCell("Days 61-90")}
                                    {getSubTableHeaderCell("Days 46-60")}
                                    {getSubTableHeaderCell("Days 31-45")}
                                    {getSubTableHeaderCell("Days 0-30")}
                                    {getSubTableHeaderCell(
                                      "Security Deposit",
                                      130
                                    )}
                                  </>
                                )}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {history
                                .filter((item) => item.netBalance > 0)
                                .map((item) => (
                                  <TableRow key={item.ageingReportId}>
                                    {getTableBodyCell(
                                      formatMoney(item.division)
                                    )}
                                    {getTableBodyCell(
                                      formatMoney(item.netBalance?.toFixed(0))
                                    )}
                                    {getTableBodyCell(
                                      formatMoney(item.overdue?.toFixed(0))
                                    )}
                                    {getTableBodyCell(
                                      formatMoney(
                                        (
                                          item.daysGreaterThan_365 +
                                          item.days331_365 / 2
                                        )?.toFixed(0)
                                      )
                                    )}

                                    {getTableBodyCell(
                                      formatMoney(
                                        item.daysGreaterThan_365?.toFixed(0)
                                      )
                                    )}
                                    {getTableBodyCell(
                                      formatMoney(item.days331_365?.toFixed(0))
                                    )}

                                    {showDetailedView && (
                                      <>
                                        {getTableBodyCell(
                                          formatMoney(
                                            item.days181_330?.toFixed(0)
                                          )
                                        )}
                                        {getTableBodyCell(
                                          formatMoney(
                                            item.days151_180?.toFixed(0)
                                          )
                                        )}
                                        {getTableBodyCell(
                                          formatMoney(
                                            item.days61_150?.toFixed(0)
                                          )
                                        )}
                                        {getTableBodyCell(
                                          formatMoney(
                                            item.days31_60?.toFixed(0)
                                          )
                                        )}
                                        {getTableBodyCell(
                                          formatMoney(item.days0_30?.toFixed(0))
                                        )}
                                        {getTableBodyCell(
                                          formatMoney(
                                            item.securityDeposit?.toFixed(0)
                                          )
                                        )}
                                      </>
                                    )}
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CollapsibleTable;
